import * as ActionTypes from '../actionTypes';

// API
import * as HttpApi from '../Api/index';

export const actionTypes = ActionTypes;

//////////////////
///// GET ////////
//////////////////
export const getList = (params) => {
        return (dispatch) => {
		return HttpApi.get('ePRODUCT_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getConfirmStepList = (params) => {
	return (dispatch) => {
		return HttpApi.get('ePRODUCT_CONFIRM_STEP_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getConfirmStepById = (params) => {
	return (dispatch) => {
		return HttpApi.get('ePRODCUT_CONFIRM_STEP_GET', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getMarkList = (params) => {
	return (dispatch) => {
		return HttpApi.get('ePRODCUT_MARK_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getMarkById = (params) => {
	return (dispatch) => {
		return HttpApi.get('ePRODCUT_MARK_GET', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getCount = (params) => {
	return (dispatch) => {
		return HttpApi.get('GET_ACCOUNT_COUNT', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getById = (params) => {
	return (dispatch) => {
		return HttpApi.get('ePRODUCT_INFO', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// POST ///////
//////////////////
export const create = (params) => {
	return (dispatch) => {
		return HttpApi.post('ePRODUCT_CREATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const createConfirmStep = (params) => {
	return (dispatch) => {
		return HttpApi.post('ePRODCUT_CONFIRM_STEP_CREATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const createMark = (params) => {
	return (dispatch) => {
		return HttpApi.post('ePRODCUT_MARK_CREATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// PUT  ///////
//////////////////
export const update = (params) => {
	return (dispatch) => {
		return HttpApi.put('ePRODUCT_UPDATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const updateStatus = (params) => {
	return (dispatch) => {
		return HttpApi.put('ePRODUCT_UPDATE_EProductStatus', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// DELETE /////
//////////////////
export const remove = () => {
    return (dispatch) => {
        return HttpApi.del('ePRODUCT_DELETE')
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

export const removeConfirmStep = (params) => {
	return (dispatch) => {
		return HttpApi.del('ePRODCUT_CONFIRM_STEP_DELETE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const removeMark = (params) => {
	return (dispatch) => {
		return HttpApi.del('ePRODCUT_MARK_DELETE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
/// FUNCTIONS ////
//////////////////
export const session = () => {
	return (dispatch) => {
		return HttpApi.get('GET_AUTH_SESSION')
			.then((response) => {
				console.log('get-auth-session', response);
				dispatch({ type: ActionTypes.LOGIN, author: response.data });
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const login = (params) => {
	return (dispatch) => {
		return HttpApi.post('eADMIN_LOGIN', params)
			.then((response) => {
				dispatch({ type: ActionTypes.LOGIN, author: response.data });
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};
